import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/impostazioni/privacy')({
  head: () => noIndexRouteHead('settingsPrivacy', 'it'),
  component: () => <SettingsPage section="datenschutz" />,
})
